import { render } from "./Quickpickup.vue?vue&type=template&id=5fbac3da"
import script from "./Quickpickup.vue?vue&type=script&lang=js"
export * from "./Quickpickup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__